import { Box, Stack, SxProps, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

export interface SubtleLabelItemProps {
  label: string;
  value: React.ReactNode;
  valueSecondary?: React.ReactNode;
  invertLabel?: boolean;
  action?: JSX.Element | null;
  sx?: SxProps<Theme>;
}

export function SubtleLabelItem({
  label,
  value,
  valueSecondary,
  action,
  invertLabel,
  sx,
}: SubtleLabelItemProps) {
  return (
    <Stack direction="row" sx={sx}>
      <Stack direction={invertLabel ? 'column-reverse' : 'column'}>
        <Typography variant="body-xs">{label}</Typography>
        <Stack direction="row" spacing={0.5} alignItems="baseline">
          <Typography variant="title-s" component="div">
            {value}
          </Typography>
          {valueSecondary && (
            <Typography variant="body-xs" component="div">
              {valueSecondary}
            </Typography>
          )}
        </Stack>
      </Stack>
      {action && <Box ml={1}>{action}</Box>}
    </Stack>
  );
}
